import { DASHBOARD_URL } from '../App';

const features = [
  {
    title: 'Advanced Reporting',
    description: 'Real-time dashboards and analytics pulled directly from your Odoo data.',
    details: [
      'Profit & Loss statements',
      'Sales analytics and trends',
      'Inventory valuation reports',
      'Custom KPI dashboards',
      'Scheduled report delivery',
    ],
  },
  {
    title: 'Team Management',
    description: 'Invite your team without additional Odoo licenses.',
    details: [
      'Unlimited team members',
      'Role-based permissions',
      'Module-level access control',
      'Activity audit logging',
      'SSO integration (coming)',
    ],
  },
  {
    title: 'Marketplace Connectors',
    description: 'Sync inventory and orders with leading e-commerce platforms.',
    details: [
      'GunBroker integration',
      'eBay integration',
      'ShipStation (coming)',
      'Amazon (coming)',
      'Custom connectors available',
    ],
  },
  {
    title: 'Enterprise Security',
    description: 'Bank-level security for your business data.',
    details: [
      'Encrypted credential storage',
      'Secure API connections',
      'Role-based access control',
      'Comprehensive audit logs',
      'SOC 2 compliance (in progress)',
    ],
  },
];

export default function FeaturesPage() {
  return (
    <div>
      {/* Hero - extends to top, nav floats over */}
      <section className="pt-32 pb-20 sm:pt-40 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-blue-400 font-semibold mb-4">Platform Features</p>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Everything you need to extend your Odoo
            </h1>
            <p className="text-xl text-white/70 leading-relaxed">
              Reporting, integrations, team management, and security. All designed to work seamlessly with your existing Odoo setup.
            </p>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="bg-gray-50 rounded-xl border border-gray-100 p-8"
              >
                <h2 className="text-2xl font-bold text-slate-900 mb-3">{feature.title}</h2>
                <p className="text-gray-600 mb-6">{feature.description}</p>

                <ul className="space-y-3">
                  {feature.details.map((detail, i) => (
                    <li key={i} className="flex items-start text-sm text-gray-600">
                      <svg
                        className="w-4 h-4 text-slate-400 mr-3 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">
            Ready to get started?
          </h2>
          <p className="text-gray-600 mb-8 max-w-xl mx-auto">
            Join the beta and start connecting your Odoo to modern interfaces today.
          </p>
          <a
            href={`${DASHBOARD_URL}/signup`}
            className="inline-flex items-center justify-center bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 rounded-lg font-medium transition-all"
          >
            Get Started
          </a>
        </div>
      </section>
    </div>
  );
}
